import { isArray } from "lodash";

export const resultToReportConfig = (
  result = {},
  { compare = false, limit = 5 } = {}
) => {
  if (!result) {
    return null;
  }

  const { dimensions = [], measures = [], filters = [] } = result;

  return {
    name: "Custom View",
    template: "custom",
    chartType: toChartType(result),
    config: {
      dataSet: "SaleItem",
      dataType: toDataType(result),
      dimensions: dimensions,
      measures: measures,
      filters:
        filters && isArray(filters)
          ? filters.map((f) => ({
              member: f.member,
              operator: "contains",
              values: f.values,
            }))
          : [],
      sort: formatSort(result),
      compare,
      limit,
      colorTheme: "default",
      timeDimension: toTimeDiemension(result),
      hideLegend: true,
      applyDateRangeFilter: toApplyDateRangeFilter(result),
    },
  };
};

export const toTimeDiemension = (result) => {
  if (result.timeDimensions) {
    return result.timeDimensions[0]?.dimension;
  }
};

export const isTimeSeries = (report) => {
  const timeSeries = report.timeDimensions;
  return timeSeries?.length && timeSeries[0]?.granularity ? true : false;
};

export const toDataType = (result) => {
  const t = isTimeSeries(result);
  return t ? "time_series" : "single";
};

export const toApplyDateRangeFilter = (result) => {
  if (!result.timeDimensions) {
    return true;
  }
  return false;
};

export const toChartType = (result) => {
  if (
    checkIfMeasureOrDimensionContainsString(
      result,
      "BusinessActivityByHourOrDay"
    )
  ) {
    return "COLUMN";
  }

  if (result.dimensions && result.timeDimensions) {
    const t = isTimeSeries(result);
    return t ? "COLUMN" : result?.dimensions?.length ? "TABLE" : "NUMBER";
  }
  return "TABLE";
};

export const formatSort = (result) => {
  if (result.order) {
    return {
      by: Object.keys(result.order)[0],
      direction: result.order[Object.keys(result.order)[0]],
    };
  }
};

export const checkIfMeasureOrDimensionContainsString = (query, str) => {
  if (
    query.measures?.some((m) => m.includes(str)) ||
    query.dimensions?.some((d) => d.includes(str))
  ) {
    return true;
  }
  return false;
};
